import { useGetRankingsTotalStats } from '~/hooks/game/useGetRankingsTotalStats';

const Levels = () => {
  const { data: statTotals } = useGetRankingsTotalStats({ enabled: true });

  return (
    <div className="levels">
      <div className="clouds-wrapper">
        <div className="clouds clouds--back">
          <img src="/img/clouds-back.png" alt="Clouds" />
        </div>
        <div className="clouds clouds--front">
          <img src="/img/clouds-front.png" alt="Clouds" />
        </div>
      </div>
      <ul className="levels-list">
        <li className="levels__item">
          <span className="name">Level 1</span>
          <span className="nbr">{statTotals?.levelStats[1]}</span>
        </li>
        <li className="levels__item">
          <span className="name">Level 2</span>
          <span className="nbr">{statTotals?.levelStats[2]}</span>
        </li>
        <li className="levels__item">
          <span className="name">Level 3</span>
          <span className="nbr">{statTotals?.levelStats[3]}</span>
        </li>
        <li className="levels__item">
          <span className="name">Level 4</span>
          <span className="nbr">{statTotals?.levelStats[4]}</span>
        </li>
        <li className="levels__item">
          <span className="name">Level 5</span>
          <span className="nbr">{statTotals?.levelStats[5]}</span>
        </li>
        <li className="levels__item">
          <span className="name">Dead</span>
          <span className="nbr">{statTotals?.levelStats.dead}</span>
        </li>
        <li className="levels__item">
          <span className="name">Burned</span>
          <span className="nbr">{statTotals?.levelStats.burned}</span>
        </li>
      </ul>
    </div>
  );
};

export default Levels;
